// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css */
/* Font Awesome for icons */

/* Top Blue Bar */
.top-bar {
  background: #E3EFF0;
  color: #0c2e7b;
  padding: 8px 0;
  font-size: 0.9rem;
}

.top-bar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  letter-spacing: 1px;
  width: 100%;
}

/* Desktop layout for top and bottom rows */
.top-bar-content .top-row,
.top-bar-content .bottom-row {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.top-bar-content .top-row {
  justify-content: space-between;
}

.top-bar-content .bottom-row {
  display: none; /* Hide on desktop */
}

.bad-weather,
.phone,
.location {
  color: #0c2e7b;
  text-decoration: none;
  transition: color 0.3s ease;
}

.bad-weather:hover,
.phone:hover,
.location:hover {
  color: #1a4fd8;
  text-decoration: none;
}

.contact-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* Desktop/mobile visibility classes */
@media (max-width: 576px) {
  .desktop-only {
    display: none !important;
  }
}

@media (min-width: 577px) {
  /* Desktop view styling */
  .bottom-row {
    display: none !important;
  }
  
  .top-row .location, 
  .top-row .bad-weather {
    display: inline-flex;
    align-items: center;
  }
  
  .phone {
    margin-right: 0; /* Reset mobile styling */
  }
}

.contact-info i {
  margin-right: 5px;
  font-size: 0.8rem;
}

.divider {
  opacity: 0.5;
  padding: 0 5px;
}

/* Main Header */
.main-header {
  background: white;
  padding: 15px 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo a {
  cursor: pointer;
  display: inline-block;
}

.logo img {
  height: auto;
  width: 350px;
  transition: opacity 0.2s ease;
}

.logo a:hover img {
  opacity: 0.9;
}

/* Navigation */
.main-nav ul {
  display: flex;
  list-style: none;
  gap: 25px;
  margin: 0 30px;
}

.main-nav a {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.05rem;
  position: relative;
  padding-bottom: 5px;
  letter-spacing: 2.1px;
}

.main-nav a:hover {
  color: #0A2463;
}

.main-nav a:hover::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #0A2463;
}

/* CTA Button */
.header-content .cta-button {
  background: #0A2463;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 1.2px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.cta-button:hover {
  background: #0A2463;
  transform: translateY(-2px);
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

/* Language Switcher */
.language-switcher {
  display: flex;
  align-items: center;
  gap: 5px;
}

.language-switcher button {
  background: none;
  border: none;
  color: #0c2e7b;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0;
  letter-spacing: 1px;
}

.language-switcher button.active {
  font-weight: bold;
}

/* Header scroll effect */
.main-header.scrolled {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* Mobile Menu Toggle Button */
.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 22px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
}

.mobile-menu-toggle span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: #0A2463;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.mobile-menu-toggle.active span:nth-child(1) {
  transform: translateY(9.5px) rotate(45deg);
}

.mobile-menu-toggle.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.active span:nth-child(3) {
  transform: translateY(-9.5px) rotate(-45deg);
}

/* Navigation Container */
.nav-container {
  display: flex;
  align-items: center;
}

/* Mobile Menu Styles */
@media (max-width: 1024px) {
  .header-content {
    position: relative;
    align-items: center;
    justify-content: space-between;
    text-align: center;
  }

  .mobile-menu-toggle {
    display: flex;
  }
  
  .nav-container {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease, box-shadow 0.3s ease;
    z-index: 1000;
    box-shadow: none;
  }
  
  .nav-container.mobile-open {
    max-height: 500px;
    padding: 20px 0;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  .main-nav {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
  }
  
  .main-nav ul {
    flex-direction: column;
    gap: 18px;
    width: 100%;
    padding: 0;
    margin: 0;
    align-items: center;
    justify-content: center;
  }
  
  .main-nav li {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
  }
  
  .main-nav a {
    display: inline-block;
    padding: 10px 0;
    font-size: 1.1rem;
    text-align: center;
    width: fit-content;
    margin: 0 auto;
  }
  
  .main-nav a::after {
    display: none;
  }
  
  .nav-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .nav-container .cta-button {
    margin: 20px auto 5px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* Medium screens */
@media (max-width: 768px) {
  .logo img {
    width: 280px;
  }
  
  .cta-button {
    padding: 10px 15px;
    font-size: 0.9rem;
  }
  
  .contact-info {
    gap: 8px;
  }
  
  .top-bar {
    font-size: 0.8rem;
  }
}

/* Small screens */
@media (max-width: 576px) {
.top-bar-content {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  gap: 8px;
  width: 100%;
}  .logo img {
    width: 220px;
  }
  
  /* First row: phone and language switcher */
  .top-bar-content .top-row {
    display: flex;
    width: 100%;
    padding: 0 15px;
    justify-content: space-between;
    align-items: center;
  }
  
  .top-bar-content .top-row .phone {
    margin-right: auto;
  }
  
  .top-bar-content .top-row .language-switcher {
    margin-left: auto;
  }
  
  /* Second row: location and weather */
  .top-bar-content .bottom-row {
    display: flex;
    width: 100%;
    padding: 0 15px;
    justify-content: space-between;
    align-items: center;
  }
  
  .contact-info {
    font-size: 0.85rem;
    display: flex; /* Changed from contents to flex */
    justify-content: flex-start;
    flex: 1 1;
  }
  
  .location {
    text-align: left;
  }
  
  .bad-weather {
    text-align: right;
  }
  
  .phone {
    text-align: left;
  }
  
  .language-switcher {
    text-align: right;
    margin-left: auto;
  }
  
  /* Keep the divider in the language switcher visible in mobile */
  .language-switcher .divider {
    display: inline-block;
    opacity: 0.5;
    padding: 0 5px;
  }
  
  /* Hide most dividers in mobile except in language switcher */
  .divider {
    display: none;
  }
  
  /* Keep language switcher divider visible */
  .language-switcher .divider {
    display: inline-block;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":"AAAA,eAAe;AACf,2BAA2B;;AAG3B,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,2CAA2C;AAC3C;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa,EAAE,oBAAoB;AACrC;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,yBAAyB;EAC5C;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,sCAAsC;AACxC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,yEAAyE;IACzE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,QAAQ;EACR,WAAW;AACb,GAAG;IACC,YAAY;EACd;;EAEA,2CAA2C;EAC3C;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa,EAAE,kCAAkC;IACjD,2BAA2B;IAC3B,SAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,gEAAgE;EAChE;IACE,qBAAqB;IACrB,YAAY;IACZ,cAAc;EAChB;;EAEA,6DAA6D;EAC7D;IACE,aAAa;EACf;;EAEA,2CAA2C;EAC3C;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* Header.css */\n/* Font Awesome for icons */\n@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');\n\n/* Top Blue Bar */\n.top-bar {\n  background: #E3EFF0;\n  color: #0c2e7b;\n  padding: 8px 0;\n  font-size: 0.9rem;\n}\n\n.top-bar-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  letter-spacing: 1px;\n  width: 100%;\n}\n\n/* Desktop layout for top and bottom rows */\n.top-bar-content .top-row,\n.top-bar-content .bottom-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.top-bar-content .top-row {\n  justify-content: space-between;\n}\n\n.top-bar-content .bottom-row {\n  display: none; /* Hide on desktop */\n}\n\n.bad-weather,\n.phone,\n.location {\n  color: #0c2e7b;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.bad-weather:hover,\n.phone:hover,\n.location:hover {\n  color: #1a4fd8;\n  text-decoration: none;\n}\n\n.contact-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n/* Desktop/mobile visibility classes */\n@media (max-width: 576px) {\n  .desktop-only {\n    display: none !important;\n  }\n}\n\n@media (min-width: 577px) {\n  /* Desktop view styling */\n  .bottom-row {\n    display: none !important;\n  }\n  \n  .top-row .location, \n  .top-row .bad-weather {\n    display: inline-flex;\n    align-items: center;\n  }\n  \n  .phone {\n    margin-right: 0; /* Reset mobile styling */\n  }\n}\n\n.contact-info i {\n  margin-right: 5px;\n  font-size: 0.8rem;\n}\n\n.divider {\n  opacity: 0.5;\n  padding: 0 5px;\n}\n\n/* Main Header */\n.main-header {\n  background: white;\n  padding: 15px 0;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.logo a {\n  cursor: pointer;\n  display: inline-block;\n}\n\n.logo img {\n  height: auto;\n  width: 350px;\n  transition: opacity 0.2s ease;\n}\n\n.logo a:hover img {\n  opacity: 0.9;\n}\n\n/* Navigation */\n.main-nav ul {\n  display: flex;\n  list-style: none;\n  gap: 25px;\n  margin: 0 30px;\n}\n\n.main-nav a {\n  color: #333;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1.05rem;\n  position: relative;\n  padding-bottom: 5px;\n  letter-spacing: 2.1px;\n}\n\n.main-nav a:hover {\n  color: #0A2463;\n}\n\n.main-nav a:hover::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #0A2463;\n}\n\n/* CTA Button */\n.header-content .cta-button {\n  background: #0A2463;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  font-weight: 600;\n  font-size: 1rem;\n  letter-spacing: 1.2px;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.cta-button:hover {\n  background: #0A2463;\n  transform: translateY(-2px);\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n}\n\n/* Language Switcher */\n.language-switcher {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.language-switcher button {\n  background: none;\n  border: none;\n  color: #0c2e7b;\n  cursor: pointer;\n  font-size: 0.9rem;\n  padding: 0;\n  letter-spacing: 1px;\n}\n\n.language-switcher button.active {\n  font-weight: bold;\n}\n\n/* Header scroll effect */\n.main-header.scrolled {\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n/* Mobile Menu Toggle Button */\n.mobile-menu-toggle {\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30px;\n  height: 22px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 10;\n}\n\n.mobile-menu-toggle span {\n  display: block;\n  height: 3px;\n  width: 100%;\n  background-color: #0A2463;\n  border-radius: 3px;\n  transition: all 0.3s ease;\n}\n\n.mobile-menu-toggle.active span:nth-child(1) {\n  transform: translateY(9.5px) rotate(45deg);\n}\n\n.mobile-menu-toggle.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.mobile-menu-toggle.active span:nth-child(3) {\n  transform: translateY(-9.5px) rotate(-45deg);\n}\n\n/* Navigation Container */\n.nav-container {\n  display: flex;\n  align-items: center;\n}\n\n/* Mobile Menu Styles */\n@media (max-width: 1024px) {\n  .header-content {\n    position: relative;\n    align-items: center;\n    justify-content: space-between;\n    text-align: center;\n  }\n\n  .mobile-menu-toggle {\n    display: flex;\n  }\n  \n  .nav-container {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: white;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 0;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease, padding 0.3s ease, box-shadow 0.3s ease;\n    z-index: 1000;\n    box-shadow: none;\n  }\n  \n  .nav-container.mobile-open {\n    max-height: 500px;\n    padding: 20px 0;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  }\n  \n  .main-nav {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n  }\n  \n  .main-nav ul {\n    flex-direction: column;\n    gap: 18px;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .main-nav li {\n    width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .main-nav a {\n    display: inline-block;\n    padding: 10px 0;\n    font-size: 1.1rem;\n    text-align: center;\n    width: fit-content;\n    margin: 0 auto;\n  }\n  \n  .main-nav a::after {\n    display: none;\n  }\n  \n  .nav-container {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n  \n  .nav-container .cta-button {\n    margin: 20px auto 5px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n/* Medium screens */\n@media (max-width: 768px) {\n  .logo img {\n    width: 280px;\n  }\n  \n  .cta-button {\n    padding: 10px 15px;\n    font-size: 0.9rem;\n  }\n  \n  .contact-info {\n    gap: 8px;\n  }\n  \n  .top-bar {\n    font-size: 0.8rem;\n  }\n}\n\n/* Small screens */\n@media (max-width: 576px) {\n.top-bar-content {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n  gap: 8px;\n  width: 100%;\n}  .logo img {\n    width: 220px;\n  }\n  \n  /* First row: phone and language switcher */\n  .top-bar-content .top-row {\n    display: flex;\n    width: 100%;\n    padding: 0 15px;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .top-bar-content .top-row .phone {\n    margin-right: auto;\n  }\n  \n  .top-bar-content .top-row .language-switcher {\n    margin-left: auto;\n  }\n  \n  /* Second row: location and weather */\n  .top-bar-content .bottom-row {\n    display: flex;\n    width: 100%;\n    padding: 0 15px;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .contact-info {\n    font-size: 0.85rem;\n    display: flex; /* Changed from contents to flex */\n    justify-content: flex-start;\n    flex: 1;\n  }\n  \n  .location {\n    text-align: left;\n  }\n  \n  .bad-weather {\n    text-align: right;\n  }\n  \n  .phone {\n    text-align: left;\n  }\n  \n  .language-switcher {\n    text-align: right;\n    margin-left: auto;\n  }\n  \n  /* Keep the divider in the language switcher visible in mobile */\n  .language-switcher .divider {\n    display: inline-block;\n    opacity: 0.5;\n    padding: 0 5px;\n  }\n  \n  /* Hide most dividers in mobile except in language switcher */\n  .divider {\n    display: none;\n  }\n  \n  /* Keep language switcher divider visible */\n  .language-switcher .divider {\n    display: inline-block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
